import React, { useContext, useEffect, useState } from "react";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import OrgContext from "../../organisation/OrgContext";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import { frFR, enUS } from "@mui/x-data-grid";
import { Modal, Button } from "react-bootstrap"; // Import Bootstrap components
import { baseURL } from "../../services/api";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const TableTva = () => {
  // states
  const { organisation } = useContext(OrgContext);
  const { t, i18n } = useTranslation();
  const [months, setMonths] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal state
  const [modalType, setModalType] = useState(""); // To store which button was clicked (Client or Fournisseur)
  const [selectedMonth, setSelectedMonth] = useState(null); // Store the selected month
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  // useEffect to fetch months
  useEffect(() => {
    getMonths();
  }, []);

  // Function to get months data
  const getMonths = async () => {
    setLoadingData(true);
    try {
      const response = await jwtInterceoptor.get(`/data/months`);
      if (response.status === 200) {
        const months = response.data.data.map((m) => ({
          ...m,
          code: m.code < 10 ? "0" + m.code : m.code,
        }));
        setMonths(months);
      }
    } catch (error) {
      console.error("Error fetching months:", error);
    }
    setLoadingData(false);
  };

  // Function to handle the modal showing
  const handleShowModal = (type, month) => {
    setModalType(type);
    setSelectedMonth(month);
    setShowModal(true);
  };

  const handleDownload = async (format) => {
    setShowModal(false);

    const orgId = organisation?.id;
    const month = selectedMonth?.code;

    if (!orgId || !month) {
      console.error("Organisation ID or Month is missing");
      return;
    }

    const url =
      modalType === "Client"
        ? `${baseURL}/data/tableauxTva/clients/${orgId}/${month}/${format}/${selectedYear}`
        : modalType === "Fournisseur"
          ? `${baseURL}/data/tableauxTva/fournisseur/${orgId}/${month}/${format}/${selectedYear}`
          : `${baseURL}/data/tableauxTva/tous/${orgId}/${month}/${format}/${selectedYear}`;

    try {
      const response = await axios.get(url, {
        responseType: "blob", // Ensure the response type is set to blob for file download
      });

      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");
      const fileExtension = format.toLowerCase() === "pdf" ? "pdf" : "csv";
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${modalType}_${month}.${fileExtension}`,
      );

      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error(t("Aucun payement passé pour ce mois."));
    }
  };

  // Preparing columns
  const columns = [
    {
      field: "Mois",
      headerName: t("Mois"),
      valueGetter: (params) =>
        i18n.language === "fr" ? params.row.name_fr : params.row.name_eng,
      width: 300,
    },
    {
      flex: 1,
      field: "Action",
      headerName: t(""),
      renderCell: (params) => (
        <div
          className="btn-list"
          // style={{
          //   width: "100%",
          //   display: "flex",
          //   justifyContent: "flex-end",
          //   gap: "10px",
          // }}
        >
          <button
            className="btn btn-sm btn-primary"
            style={{ padding: "5px 10px", cursor: "pointer" }}
            onClick={() => handleShowModal("Client", params.row)}
          >
            {t("Client")}
          </button>
          <button
            className="btn btn-sm btn-info"
            style={{ padding: "5px 10px", cursor: "pointer" }}
            onClick={() => handleShowModal("Fournisseur", params.row)}
          >
            {t("Fournisseur")}
          </button>
          <button
            className="btn btn-sm btn-warning"
            style={{ padding: "5px 10px", cursor: "pointer" }}
            onClick={() => handleShowModal("total Tva", params.row)}
          >
            {t("total Tva")}
          </button>
        </div>
      ),
    },
  ];

  const [years, setYears] = useState([]);
  // Générer la liste d'années
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = 2000;
    const yearList = [];

    for (let year = currentYear; year >= startYear; year--) {
      yearList.push(year);
    }

    setYears(yearList);
  }, []);

  // Gérer la sélection de l'année
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
    console.log("Année sélectionnée :", e.target.value);
    // Vous pouvez appeler une fonction ici pour filtrer vos données par l'année sélectionnée
  };
  return (
    <div>
      {/* <div className="" style={{ marginBottom: "10px" }}>
        <h1 style={{ fontSize: 50 }}>Tableau de TVA </h1>
      </div> */}
       <div className="container-fluid">
       
        <div className="main-container container-fluid">
          <div className="page-header">
            <h1 className="page-title breadcumpsHeader">Tableau de TVA</h1>
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0)">Comptabilité</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Tableau de TVA
                </li>
              </ol>
            </div>
          </div>
        </div>


      <div className="row" style={{ zIndex: 1 }}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="col-md-4 animation-hover mb-4">
                <div className="card" style={{ padding: 20 }}>
                  <label htmlFor="year-select">Sélectionnez une année : </label>
                  <select
                    id="year-select"
                    className="form-select"
                    onChange={handleYearChange}
                  >
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="table-responsive">
                <div style={{ height: "600px", width: "100%" }}>
                  <DataGrid
                    rows={months}
                    columns={columns}
                    density={"compact"}
                    hideFooterPagination={true}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 20 },
                      },
                    }}
                    pageSizeOptions={[20]}
                    loading={loadingData}
                    localeText={
                      i18n.language === "fr"
                        ? frFR.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    slots={{
                      toolbar: GridToolbar,
                      loadingOverlay: LinearProgress,
                    }}
                    componentsProps={{
                      toolbar: {
                        csvOptions: { disableToolbarButton: true },
                        printOptions: { disableToolbarButton: true },
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</div>
      {/* Modal for downloading options */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Choisissez le format de téléchargement")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {t(
              "Veuillez sélectionner le format dans lequel vous souhaitez télécharger les données.",
            )}
            :
          </p>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Button variant="success" onClick={() => handleDownload("PDF")}>
              {t("Télécharger le PDF")}
            </Button>
            <Button variant="info" onClick={() => handleDownload("CSV")}>
              {t("Télécharger le CSV")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default TableTva;
